<div *ngIf="!isLoadingLabels && !isLoadingModal">
	<ng-container>
		<div class="input-line mt-3">
			<div class="header-line">{{ labels.lbl_geral_informacoes_estoque_ci }}</div>
			<div class="input-container">
				<div class="input-line">
					<span>{{ labels.lbl_cmdb_availbility }}</span>
					<span><input type="text" [value]="qtdAvailables ? qtdAvailables : '0'" disabled /></span>
				</div>
				<div class="input-line">
					<span>{{ labels.lbl_geral_quantidade_emprestada }}</span>
					<span><input type="text" [value]="qtdLoan ? qtdLoan : '0'" disabled /></span>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	class="mt-2 ml-2"
	*ngIf="isLoadingLabels || isLoadingModal"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
